
import { Component, Inject, OnInit, } from '@angular/core';
import { Functions, httpsCallableData } from '@angular/fire/functions';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Conversation, ConversationMessage } from 'src/app/core/models/conversation.model';
import { User } from 'src/app/core/models/user';
import { AuthService } from 'src/app/core/services/auth.service';
import { ConversationsService } from 'src/app/core/services/conversations.service';
import { UserService } from 'src/app/core/services/user.service';
@Component({
  selector: 'app-write-message',
  templateUrl: './write-message.component.html',
  styleUrls: ['./write-message.component.scss']
})
export class WriteMessageComponent {

  public Editor = ClassicEditor;
  toUser: string;
  user: User;
  message: string;
  subjectForm: FormGroup;
  existingConversation: Conversation;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private conversationsService: ConversationsService, private fns: Functions, private authService: AuthService, private userService: UserService, private parentDilogRef: MatDialogRef<WriteMessageComponent>, private fb: FormBuilder) {
    this.subjectForm = this.fb.group({

    });

    this.toUser = this.data.toName;
    const existingConvoDocId = this.data.existingConvoDocId;
    this.getConvo(existingConvoDocId);
    this.authService.currentUser.subscribe((user) => {
      this.user = user;
      console.log('MSG INIT ', this.user);
      console.log('Form Value', this.subjectForm.value);

    });
  }
  async getConvo(existingConvoDocId: any) {
    if (existingConvoDocId) {
      this.existingConversation = await this.conversationsService.getConversationById(existingConvoDocId)
    }
  }


  sendMessage() {
    if (this.message?.length > 0) {
      const convo = new Conversation();
      convo.docId = '';
      convo.members = [this.data.toId, this.user.userId];
      const msg = new ConversationMessage();
      msg.message = this.message;
      msg.from = `${this.user.firstName} ${this.user.lastName}`;
      msg.fromUserId = this.user.userId;
      msg.fromProfilePicture = this.user.profilePicture;
      msg.isRead = false;
      msg.sentDate = new Date();
      msg.to = this.data.toName;
      msg.toUserId = this.data.toId;
      msg.fromProfilePicture = this.user.profilePicture;
      if (this.existingConversation?.docId) {
        this.existingConversation.messages.push(msg);
        this.conversationsService.updateConversation(this.existingConversation);
      } else {
        convo.messages = [msg];
        this.conversationsService.insertNewConversation(convo);
      }
      console.log(convo);
      this.sendAlertToReciever().subscribe(rep => {
        console.log(rep);
      });
      this.parentDilogRef.close();
    }
  }

  cancel() {
    this.parentDilogRef.close();
  }

  public onChange({ editor }: ChangeEvent) {
    const data = editor.data.get()
    this.message = data;
  }

  sendAlertToReciever() {
    const callable = httpsCallableData(this.fns, 'notifications-sendNewMessageAlert');
    return callable({ toUserId: this.data.toId, name: this.user.firstName + ' ' + this.user.lastName, message: this.message });
  }

}
